import { push } from "connected-react-router";
import useSchema from "hooks/useSchema";
import { isEmpty } from "lodash";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { actions as creditBillActions } from "reducers/creditBills";
import { formatAction, TRANSMISSION } from "util/creditBills";
import * as Yup from "yup";

export const useAction = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { actionData } = useSelector((_state) => _state.creditBills);
    const { actionI18n, actionInLowerCase } = formatAction(actionData?.action);

    const { stringRequired } = useSchema();

    const getInitiaValues = () => {
        if (actionData?.action?.includes(TRANSMISSION)) {
            return { motive: actionData.motive ?? "", transmissionType: "NOM" };
        }
        return { motive: actionData.motive ?? "" };
    };

    const validationSchema = Yup.object().shape({
        motive: stringRequired,
    });

    const handleSubmit = useCallback(
        (values) => {
            const prepareData = {
                ...actionData,
                ...values,
            };
            dispatch(creditBillActions.setActionData(prepareData));
            dispatch(push(`/creditBills/${actionInLowerCase}/confirm`));
        },
        [actionData, dispatch],
    );

    useEffect(() => {
        if (actionData?.invoiceList?.length === 0 || isEmpty(actionData)) {
            history.goBack();
        }
    }, []);

    return {
        form: {
            handleSubmit,
            validationSchema,
            initialValues: getInitiaValues(),
        },
        tabOption: actionData.tabOption,
        bills: actionData.invoiceList,
        actionI18n,
    };
};

export default useAction;
